<ngx-charts-number-card
  [scheme]="colorScheme"
  [results]="formattedDataNGX"
  [cardColor]="cardColor"
  (select)="onSelect($event)"
  [view]="view">
</ngx-charts-number-card>